import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import FormHelperText from '@mui/material/FormHelperText';

import {copyTextToClipboard} from '../shared/Utilities';
import Session from '../shared/Session';


// TEXT TO SPEECH
// https://www.npmjs.com/package/tts-react

export default function AI() {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState("");

    const handleInputChange = (event: any) => {
        setInput(event.target.value);
    };

    const handleSubmit = () => {
        Session.api("POST", `/ai`, {input: input, type: "default"}, setOutput);
    };

    return <>
        <div id="audio"></div>
        <Typography variant="h4" align="left" gutterBottom component="h2">
            AI
        </Typography>
        <TextField
            autoFocus={true}
            fullWidth={true}
            rows={5}
            key={"ai-input"}
            id={"ai-input"}
            type="text"
            multiline
            helperText="Enter a prompt in the text area. This will be used with OpenAI GPT-4 to generate a response."
            onChange={handleInputChange}
            variant="standard"
            size="medium"
        />
        <Button variant="outlined" size="large" onClick={handleSubmit}>Submit</Button>&nbsp;&nbsp;
        <Button variant="outlined" size="large" onClick={() => {
            (document.getElementById("ai-input") as HTMLInputElement).value = "";
            setOutput("");
        }}>Clear</Button>&nbsp;&nbsp;
        <br />
        <br />
        { output === "" ? "" : 
            <>
                <FormHelperText>Click to copy</FormHelperText>
                <Paper
                    className='sj-paper' 
                    onClick={() => { copyTextToClipboard(output); }}><pre>
                    {output}
                </pre></Paper>
            </>
        }
    </>;
}
